import { BiteLogVerifonePointCloudEvent } from './bite_log_verifone_point_cloud_event.js';

export function name(event: BiteLogVerifonePointCloudEvent): string {
  switch (event) {
    case BiteLogVerifonePointCloudEvent.TerminalDisconnected:
      return 'terminal-disconnected';
  }
}
